import { render, staticRenderFns } from "./call-center-queue.vue?vue&type=template&id=f108bb16"
import script from "./call-center-queue.vue?vue&type=script&lang=ts"
export * from "./call-center-queue.vue?vue&type=script&lang=ts"
import style0 from "./call-center-queue.vue?vue&type=style&index=0&id=f108bb16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VLayout,VList,VListItem,VListItemContent,VRow})
